/* eslint-disable id-blacklist */
export enum ConfigValueType {
  String = 'String',
  Number = 'Number',
  Boolean = 'Boolean',
  Integer = 'Integer',
}
